export const emissionErrors = {
	title: "Errores de emisión",
	period: "Período",
	export: "Exportar Excel",
	drawer: {
		title: "Historial de errores",
		message: "Mensaje",
		type: "Tipo de error",
		profile: "Perfil fiscal",
		count: "Cantidad",
		date: "Primer día no emitido",
		updatedAt: "Último día no emitido",
		status: "Estado",
		attemptsTitle: "Últimos intentos de emisión",
		productsTitle: "Productos no emitidos",
		noAttempts: "No se encontraron intentos de emisión",
		noProducts: "No se encontraron productos no emitidos",
		attemptsTable: {
			client: "Cliente",
			date: "Fecha",
			error: "Error",
		},
		productsTable: {
			product: "Producto",
			count: "Cantidad",
		},
	},
	tabs: {
		invoices: "Notas emitidas",
		products: "Productos no emitidos",
	},
	table: {
		statusLabel: {
			pending: "Pendiente",
			resolved: "Resuelto",
		},
		errorTypeLabel: {
			unknown: "Desconocido",
		},
		columns: {
			errorMessage: "Mensaje",
			errorType: "Tipos de error",
			fiscalProfileId: "Perfil fiscal",
			count: "Cantidad",
			createdAt: "Primer día no emitido",
			updatedAt: "Último día no emitido",
			status: "Estado",
		},
	},
};
